export default __webpack_public_path__ + "static/media/Isha_.f1e0f4b0.png";